export { default as ProductDetailsCarousel } from './ProductDetailsCarousel'
export { default as ProductDetailsSummary } from './ProductDetailsSummary'
export { default as ProductDetailsContent } from './ProductDetailsContent'
export { default as ProductDetailsSimilar } from './ProductDetailsSimilar'
